/**
 * Permalink helpers for real (path-based) routes. Routing itself lives in
 * `router.tsx` (TanStack Router); these just build copy-pasteable hrefs.
 *
 *   /p/<projectId>     — open a project (survives page reload)
 *   /frame/<frameId>   — open a single frame in isolation in a new tab
 *
 * Deep links work on the static host because CloudFront rewrites 403/404 →
 * /index.html (see infra/lib/frontend-stack.ts) and Vite dev defaults to SPA
 * fallback.
 */

/** The path for a project, e.g. `/p/abc123`. */
export function projectHref(id: string): string {
  return `/p/${encodeURIComponent(id)}`;
}

/** The path for an isolated frame, e.g. `/frame/abc123`. */
export function frameHref(id: string): string {
  return `/frame/${encodeURIComponent(id)}`;
}

/** A full, copy-pasteable permalink for a frame on the current origin. */
export function framePermalink(id: string, base = window.location.origin): string {
  return `${base}${frameHref(id)}`;
}
